import React from "react";

export default function SQL_Min_Max() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Min_Max</h1>
      <p>This is the SQL_Min_Max component generated from the SQL JSON.</p>
    </div>
  );
}
